'use client';

import { Button, Modal } from '@common/components';
import { useEffect, useState } from 'react';

import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useGlobalStore } from '@/stores/GlobalStore';
import {
  APP_DOWNLOAD_QR_SRC,
  isMobileAppDownloadDevice,
} from '@/utils/appDownload';

export const AppInstallConfirmModal = () => {
  const router = useCustomRouter();
  const [isMobileDevice, setIsMobileDevice] = useState(() =>
    isMobileAppDownloadDevice(),
  );
  const [isShowAppInstallConfirmModal, setIsShowAppInstallConfirmModal] =
    useGlobalStore((state) => [
      state.isShowAppInstallConfirmModal,
      state.setIsShowAppInstallConfirmModal,
    ]);
  const showQrCode = !isMobileDevice;

  useEffect(() => {
    if (!isShowAppInstallConfirmModal) return;

    setIsMobileDevice(isMobileAppDownloadDevice());
  }, [isShowAppInstallConfirmModal]);

  const handleClose = () => setIsShowAppInstallConfirmModal(false);

  const handleClickConfirm = () => {
    if (!isMobileAppDownloadDevice()) {
      setIsMobileDevice(false);

      return;
    }

    setIsShowAppInstallConfirmModal(false);
    router.push(ROUTES.APP_DOWNLOAD.pathname);
  };

  return (
    <Modal
      className="flex max-h-[calc(100dvh-48px)] flex-col items-center"
      opened={isShowAppInstallConfirmModal}
      onClose={handleClose}
    >
      <p className="mb-8 font-700 text-Gray-900 typo-body1">알림</p>
      <p className="mb-12 text-center font-400 text-Gray-700 typo-body3">
        광고에 참여하고 웰포인트를 더 쌓아보세요.
      </p>

      {showQrCode ? (
        <div className="mb-24 flex flex-col items-center">
          <Image
            alt="웰로 앱 다운로드 QR코드"
            className="size-200"
            height={200}
            src={APP_DOWNLOAD_QR_SRC}
            unoptimized
            width={200}
          />
        </div>
      ) : null}

      <footer className="flex w-full gap-8">
        <Button
          className="flex-1"
          dimensions="H48"
          theme="sub-line"
          onClick={handleClose}
        >
          닫기
        </Button>
        {showQrCode ? null : (
          <Button
            className="flex-1"
            dimensions="H48"
            onClick={handleClickConfirm}
          >
            설치하기
          </Button>
        )}
      </footer>
    </Modal>
  );
};
